import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskHeading, EASE } from "./motion";

export const PageHero = ({ eyebrow, lines, intro, img, imgAlt, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);
  return (
    <section ref={ref} className="relative bg-[var(--ink)] blueprint grain pt-36 lg:pt-44 pb-16 lg:pb-24 overflow-hidden" data-testid={testId}>
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid gap-12 lg:grid-cols-12 items-end">
        <div className="lg:col-span-7">
          <motion.p initial={{ opacity: 0, x: -16 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, ease: EASE }} className="eyebrow mb-6 flex items-center gap-3">
            <span className="w-10 h-px bg-[var(--orange)]" />{eyebrow}
          </motion.p>
          <MaskHeading as="h1" onLoad lines={lines} className="font-display font-black uppercase text-[14vw] sm:text-7xl lg:text-[7rem] leading-[0.86]" />
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE, delay: 0.5 }}
            className="mt-8 max-w-xl text-base lg:text-lg text-zinc-300 leading-relaxed">{intro}</motion.p>
        </div>
        {img && (
          <motion.div initial={{ clipPath: "inset(0 0 100% 0)" }} animate={{ clipPath: "inset(0 0 0% 0)" }} transition={{ duration: 1.3, ease: EASE, delay: 0.3 }}
            className="lg:col-span-5 relative clip-cut overflow-hidden aspect-[16/11]">
            <motion.img src={img} alt={imgAlt} style={{ y, scale: 1.15 }} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/60 to-transparent" />
          </motion.div>
        )}
      </div>
    </section>
  );
};
